import React from "react";
import {HelpDirectoryRepository} from "../../../repository";
import {HelpDirectory} from "../../../model";
import {EntityReadTemplate} from "../../../component/template/EntityReadTemplate";

export const ReadHelpDirectory = () => {

    return (
        <EntityReadTemplate<HelpDirectory>
            repository={new HelpDirectoryRepository()}
            title={{
                page: `Document (Aide en ligne)`,
                schema: `$0`,
                params: [`name`]
            }}
            attributes={[
                { label: `Nom`, key: 'name' },
                { label: `Permission`, key: 'permission' },
                { label: `Nombre de fichiers`, key: 'numberOfFiles' },
            ]}
        />
    )
}